export default {
      id: "ic_play-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ic_play-usage",
      toString: function () {
        return this.url;
      }
    }